import { render } from "./TurmaEstatisticas.vue?vue&type=template&id=1e90ca47&scoped=true"
import script from "./TurmaEstatisticas.vue?vue&type=script&lang=js"
export * from "./TurmaEstatisticas.vue?vue&type=script&lang=js"

import "./TurmaEstatisticas.vue?vue&type=style&index=0&id=1e90ca47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e90ca47"]])

export default __exports__